// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName
import { application } from "./application";

import SidebarController from "./sidebar_controller";
application.register("sidebar", SidebarController);

import TurnstileController from "./turnstile_controller";
application.register("turnstile", TurnstileController);

import AnnouncementController from "./announcement_controller";
application.register("announcement", AnnouncementController);

import InstitutionSearchController from "./institution_search_controller";
application.register("institution-search", InstitutionSearchController);
